import React, { useState, useEffect } from "react";
import { Table, Space, Button, Tooltip, Spin } from "antd";
import { BsEye } from "react-icons/bs";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../Pagination";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getUnAssignedSurvey } from "../../../api/CommonRequest";
import { BiSolidEdit, BiUserCircle } from "react-icons/bi";

const UnAssignedSurveyList = () => {
  const navigate = useNavigate();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [surveyData, setSurveyData] = useState([]);

  // Fetch data from backend
  useEffect(() => {
    const surveyCall = async () => {
      try {
        setLoader(true);
        const { data } = await getUnAssignedSurvey({
          page: currentPage,
          limit: limit,
        });
        if (data?.success) {
          setSurveyData(data?.surveyList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);

          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    surveyCall();
    setSelectedRowKeys([]);
  }, [limit, currentPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
  };

  const assignedColumns = [
    {
      title: "Survey Name",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
    },
    { title: "State", dataIndex: "state", key: "state" },
    { title: "District", dataIndex: "district", key: "district" },
    { title: "City", dataIndex: "city", key: "city" },

    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => moment(date).format("DD MMM YYYY"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View Details">
            <button
              onClick={() => navigate("/survey-single-view", { state: record._id })}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <BsEye size={16} />
            </button>
          </Tooltip>

          <Tooltip title="Edit Survey">
            <button
              onClick={() => navigate("/survey-update", { state: record })}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <BiSolidEdit size={16} />
            </button>
          </Tooltip>

          <Tooltip title="Assign Surveyor">
            <button
              onClick={() => navigate("/survey-assign", { state: record._id })}
              className="w-8 h-8 flex items-center justify-center bg-yellow-50 text-yellow-600 rounded-lg hover:bg-yellow-600 hover:text-white transition-all shadow-sm border border-yellow-100"
            >
              <BiUserCircle size={18} />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Spin spinning={loader}>
      <div className="pt-[0px] space-y-10">
        <Table
          columns={assignedColumns}
          rowSelection={rowSelection}
          dataSource={surveyData}
          pagination={false}
          size="small"
          className="custom-table-header w-full overflow-x-auto custom-pagination border border-gray-100 rounded-xl"
          rowKey="_id"
        />

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          limit={limit}
          totalItem={totalItems}
          onPageChange={handlePageChange}
          handleLimit={handleLimit}
        />
      </div>
    </Spin>
  );
};

export default UnAssignedSurveyList;
